import styled from 'styled-components/macro';

import { distances, colors, border } from '../../styles/constants';

const ButtonExternalLink = styled.a`
    border: none;
    padding: 10px ${distances.small};
    min-width: 138px;
    border-radius: 2px;
    color: ${colors.background};
    background: ${colors.primary};
    border: ${border.normal} solid ${colors.primary};
    text-decoration: none;
    user-select: none;
    font-weight: 700;
    font-size: 14px;

    &:hover {
        background: ${colors.primaryHover};
        border: ${border.normal} solid ${colors.primaryHover};
    }

    &:focus {
        outline: none;
    }

    &.alt {
        background: transparent;
        color: ${colors.primary};
        border: ${border.normal} solid ${colors.borderLight};

        &:hover {
            border: ${border.normal} solid ${colors.primary};
        }
    }
`;

export default ButtonExternalLink;
